import type { CSSProperties } from 'react';

export type StyleXPropsResult = {
  className?: string;
  style?: Readonly<Record<string, string | number>>;
  [key: string]: unknown;
};

export function mergeStylexProps(
  stylexResult: StyleXPropsResult
): StyleXPropsResult;
export function mergeStylexProps(
  stylexResult: StyleXPropsResult,
  style?: CSSProperties
): StyleXPropsResult;
export function mergeStylexProps(
  stylexResult: StyleXPropsResult,
  className: string,
  style?: CSSProperties
): StyleXPropsResult;
export function mergeStylexProps(
  stylexResult: StyleXPropsResult,
  classNameOrStyle?: string | CSSProperties,
  style?: CSSProperties
): StyleXPropsResult {
  const externalClassName =
    typeof classNameOrStyle === 'string' ? classNameOrStyle : undefined;
  const externalStyle =
    typeof classNameOrStyle === 'object' ? classNameOrStyle : style;

  const mergedClassName = [stylexResult.className, externalClassName]
    .filter(Boolean)
    .join(' ');

  const mergedStyle = externalStyle
    ? { ...stylexResult.style, ...externalStyle }
    : stylexResult.style;

  return {
    ...stylexResult,
    className: mergedClassName || undefined,
    style: mergedStyle,
  };
}
